// extracted by mini-css-extract-plugin
export var alertIcon = "_oz-0";